<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <gg-card-title class="pb-0 pt-0">
          Manage Domain Names
        </gg-card-title>
      </v-col>
      <v-col cols="12" md="6" class="text-right">
        <div class="hidden-xs-only">
          <gg-btn class="mr-1" tile elevation="0" color="primary" right :to="{ name: 'domain_registration' }">
            Register a Domain
          </gg-btn>
          <gg-btn class="mx-1" tile elevation="0" secondary right :to="{ name: 'domain_transfer' }">
            Transfer a Domain
          </gg-btn>
        </div>
        <div class="hidden-sm-and-up">
          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on }">
              <gg-btn v-on="on"
                     tile elevation="0"
                     small
                     secondary>
                Actions <v-icon right dark>mdi-menu-down</v-icon>
              </gg-btn>
            </template>
            <v-list>
              <v-list-item :to="{ name: 'domain_registration' }">
                <v-list-item-title>Register Domain</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'domain_transfer' }">
                <v-list-item-title>Transfer Domain</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <v-row>

    </v-row>

    <domains-transfer-list></domains-transfer-list>

    <gg-card>
      <gg-card-header>
        <div class="d-flex flex-sm-row flex-column justify-between align-start gap-sm align-md-center">
          <h2>My Domain Names</h2>
          <div class="w-100" style="max-width: 440px">
            <services-search v-model="search" compact />
          </div>
        </div>
      </gg-card-header>
      <gg-card-text>
        <v-data-table :loading="!domainsPopulated"
                      :headers="headers"
                      :items="managableDomains"
                      :footer-props="{ itemsPerPageOptions: pagination }"
                      :search="search">
          <template v-slot:item.renewaldate="{ item }">
            {{ formatRenewalDate(parseRenewalDate(item.renewaldate)) }}
          </template>
          <template v-slot:item.domain="{ item }">
            <router-link :to="`/domains/${item.id}`" class="ggs-item-title">
              {{ item.domain }}
            </router-link>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <router-link
                  v-if="item.cancellation_pending"
                  :to="`/cancellations/${item.cancellation_id}`"
                  aria-label="View Request"
                  class="pl-1"

                >
                  <v-icon color="orange" small v-on="on" v-bind="attrs">mdi-alert-outline</v-icon>
                </router-link>
              </template>
              <div>Your service will be active until the due date.</div>
              <div>Click to view/update your request.</div>
            </v-tooltip>
          </template>
          <template v-slot:item.status="{ item }">
            <v-icon small class="pb-1" :color="statusColor(item.status)">
              mdi-circle
            </v-icon>
            <span class="pl-1">
              {{ item.status }}
            </span>
          </template>
          <template v-slot:item.idprotect="{ item }">
            <v-icon
              small
              class="pb-1"
              :color="idProtectColor(item.idprotect, item.idprotect_eligible, item.idprotect_status)"
            >
              mdi-circle
            </v-icon>
            <span class="pl-1">
            {{ idProtectStatus(item.idprotect, item.idprotect_eligible, item.idprotect_status) }}
          </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <gg-btn v-if="serviceManagable(item)" color="primary" tile :to="`/domains/${item.id}`">
              Manage
            </gg-btn>
          </template>
        </v-data-table>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { statusColor, serviceManagable, parseRenewalDate, formatRenewalDate } from '@/helpers/helpers'
import DomainsTransferList from '@/components/Domains/DomainsTransferList'
import ServicesSearch from 'Components/Services/Hosting/ServicesPage/ServicesSearch'

export default {
  name: 'DomainsList',
  components: {
    DomainsTransferList,
    ServicesSearch
  },
  data: () => ({
    headers: [
      {
        text: 'Domain',
        value: 'domain',
        sortable: true,
      },
      {
        text: 'Status',
        value: 'status',
        sortable: true,
      },
      {
        text: 'ID Protect',
        value: 'idprotect',
        sortable: true,
      },
      {
        text: 'Expiry Date',
        value: 'renewaldate',
        sortable: true,
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'center',
        sortable: false,
      }
    ],
    search: ''
  }),
  methods: {
    parseRenewalDate,
    formatRenewalDate,
    statusColor,
    serviceManagable,
    idProtectColor (status, eligible, enom) {
      if (!eligible) {
        return 'grey'
      }
      if (eligible && !enom) {
        return 'orange'
      }
      return this.statusColor(status)
    },
    idProtectStatus (whmcs, eligible, enom) {
      if (whmcs == '1' && enom == true) {
        return 'Enabled'
      } else if (!eligible) {
        return 'N/A'
      } else {
        return 'Disabled'
      }
    }
  },
  computed: {
    ...mapGetters(['domainQueue', 'domains', 'domainsPopulated', 'pagination']),
    managableDomains () {
      return this.domains.reduce((carry, domain) => {
        if (serviceManagable(domain)) {
          carry.push(domain)
        }
        return carry
      }, [])
    },
  }
}
</script>
